
<template>

    <Head :title="title"></Head>

    <div id="layout" class="min-h-screen w-screen grid bg-grey relative">

        <Banner />


        <Logo class="w-36 mb-4"
            href="https://pausefitness.kinsta.cloud/"
            style="grid-area: logo" />


        <h2 class="font-nexa text-3xl text-blue mb-3 mt-3"
            style="grid-area: title">

            {{ title }}

        </h2>


        <div class="text-lg text-blue font-nexa"
             style="grid-area: description"
             v-if="description">

            {{ description }}

        </div>


        <div class="my-6"
             style="grid-area: form">

            <slot></slot>

        </div>


        <div class="relative hidden xl:block w-full h-full bg-no-repeat bg-opacity-80 overflow-hidden bg-contain"
             style="
                grid-area: faded_logo;
                background-position: bottom right;
                background-image: url('/images/faded-logo.png');
            ">
        </div>


    </div>

</template>

<script>

import { defineComponent } from "vue";
import Logo from '@/Components/Logo.vue';
import LanguageSelector from "@/Components/LanguageSelector.vue";
import Banner from '@/Components/Banner.vue';
import { Head } from '@inertiajs/inertia-vue3';

export default defineComponent({

    props: {
        title: String,
        description: String
    },


    components: {
        Head,
        Logo,
        Banner,
        LanguageSelector
    },

});

</script>

<style scoped>

#layout {
    grid-template-columns: 30px min-content auto 30px;
    grid-template-rows: 30px auto min-content min-content min-content auto 30px;
    grid-template-areas:
            ". . . ."
            ". logo . ."
            ". title title ."
            ". description description ."
            ". form form ."
            ". . . ."
            ". . . ."
    ;
}

@media (min-width: 768px) {
    #layout {
        grid-template-columns: 60px auto minmax(min-content,425px) auto 60px;
        grid-template-rows: 60px auto min-content min-content min-content auto 60px;
        grid-template-areas:
            ". . . . ."
            ". logo logo logo ."
            ". . title . ."
            ". . description . ."
            ". . form . ."
            ". . . . ."
            ". . . . ."
    ;
    }
}

@media (min-width: 1280px) {

    #layout {
        grid-template-columns: 120px 426px auto 1fr;
        grid-template-rows: 110px min-content min-content min-content min-content auto 110px;
        grid-template-areas:
            ". . . ."
            ". logo . faded_logo"
            ". title . faded_logo"
            ". description . faded_logo"
            ". form . faded_logo"
            ". . . faded_logo"
            ". . . faded_logo"
        ;
    }
}

</style>
